module.exports = __webpack_public_path__ + "static/lifetimeDesktop-bad986d429b4efbb64f153f9c7075e8d.jpg";